import rpc from './core'

const urls = {
  posts: {
    url: '/blog/{parish}/posts',
    method: 'GET'
  },
  photos: {
    url: '/blog/{parish}/photos',
    method: 'GET'
  },
  videos: {
    url: '/blog/{parish}/videos',
    method: 'GET'
  },
  library: {
    url: '/blog/{parish}/library',
    method: 'GET'
  },
  post: {
    url: '/blog/{parish}/post/{post}',
    method: 'GET'
  },
  video: {
    url: '/blog/{parish}/video/{video}',
    method: 'GET'
  },
  save_post: {
    url: '/blog/{parish}/post',
    method: 'POST'
  },
  save_photo: {
    url: '/blog/{parish}/photo',
    method: 'POST'
  },
  save_video: {
    url: '/blog/{parish}/video',
    method: 'POST'
  },
  delete_photo: {
    url: '/blog/{parish}/photo/{photo}/delete',
    method: 'POST'
  },
  delete_video: {
    url: '/blog/{parish}/video/{video}/delete',
    method: 'POST'
  },
  save_catalog: {
    url: '/blog/{parish}/catalog',
    method: 'POST'
  },
  save_file: {
    url: '/blog/{parish}/file',
    method: 'POST'
  },
  remove_catalog: {
    url: '/blog/{parish}/catalog/{catalog}/remove',
    method: 'POST'
  },
  remove_file: {
    url: '/blog/{parish}/file/{file}/remove',
    method: 'POST'
  },
  about_priest: {
    url: '/priests/{priest}',
    method: 'GET'
  },
  send_comment_post: {
    url: '/blog/{parish}/post/{post}/comment',
    method: 'POST'
  },
  send_comment_photo: {
    url: '/blog/{parish}/photo/{photo}/comment',
    method: 'POST'
  },
  send_comment_video: {
    url: '/blog/{parish}/video/{video}/comment',
    method: 'POST'
  },
  delete_comment_post: {
    url: '/blog/{parish}/post/{post}/comment/{comment}/delete',
    method: 'POST'
  },
  delete_comment_photo: {
    url: '/blog/{parish}/photo/{photo}/comment/{comment}/delete',
    method: 'POST'
  },
  delete_comment_video: {
    url: '/blog/{parish}/video/{video}/comment/{comment}/delete',
    method: 'POST'
  },
  vote_post: {
    url: '/blog/{parish}/post/{post}/vote',
    method: 'POST'
  },
  vote_photo: {
    url: '/blog/{parish}/photo/{photo}/vote',
    method: 'POST'
  },
  vote_video: {
    url: '/blog/{parish}/video/{video}/vote',
    method: 'POST'
  }
}

const loadAboutPriest = async (priest) => {
  return rpc({ params: { priest: priest.id }, ...urls['about_priest'] })
}
const loadPosts = async (parish, limit, offset) => {
  limit = limit || 10
  offset = offset || 0
  return rpc({ params: { parish: parish.id, limit, offset }, ...urls['posts'] })
}
const loadPhotos = async (parish, limit, offset) => {
  limit = limit || 40
  offset = offset || 0
  return rpc({ params: { parish: parish.id, limit, offset }, ...urls['photos'] })
}
const loadVideos = async (parish, limit, offset) => {
  limit = limit || 10
  offset = offset || 0
  return rpc({ params: { parish: parish.id, limit, offset }, ...urls['videos'] })
}
const loadLibrary = async (parish) => {
  return rpc({ params: { parish: parish.id }, ...urls['library'] })
}
const removeLibraryItem = async (parish, item) => {
  switch (item.type) {
    case 'catalog':
      return rpc({ params: { parish: parish.id, catalog: item.id }, ...urls['remove_catalog'] })
    case 'file':
      return rpc({ params: { parish: parish.id, file: item.id }, ...urls['remove_file'] })
    default:
      console.error('unknown library item type')
  }
}
const loadPost = async (parish, post) => {
  return rpc({ params: { parish: parish.id, post: post.id }, ...urls['post'] })
}
const loadVideo = async (parish, video) => {
  return rpc({ params: { parish: parish.id, video: video.id }, ...urls['video'] })
}
const savePost = async (parish, post) => {
  return rpc({ params: { parish: parish.id }, data: { blog_post: post }, ...urls['save_post'] })
}
const savePhoto = async (parish, images) => {
  return rpc({ params: { parish: parish.id }, data: { blog_photo: { images } }, ...urls['save_photo'] })
}
const saveVideo = async (parish, video) => {
  return rpc({ params: { parish: parish.id }, data: { blog_video: video }, ...urls['save_video'] })
}
const saveCatalog = async (parish, catalog) => {
  return rpc({ params: { parish: parish.id }, data: { blog_catalog: catalog }, ...urls['save_catalog'] })
}
const saveFile = async (parish, file) => {
  return rpc({ params: { parish: parish.id }, data: { blog_file: file }, ...urls['save_file'] })
}
const sendCommentForPost = async (parish, post, comment) => {
  return rpc({ params: { parish: parish.id, post: post.id }, data: { comment }, ...urls['send_comment_post'] })
}
const sendCommentForPhoto = async (parish, photo, comment) => {
  return rpc({ params: { parish: parish.id, photo: photo.id }, data: { comment }, ...urls['send_comment_photo'] })
}
const sendCommentForVideo = async (parish, video, comment) => {
  return rpc({ params: { parish: parish.id, video: video.id }, data: { comment }, ...urls['send_comment_video'] })
}
const votePost = async (parish, post) => {
  return rpc({ params: { parish: parish.id, post: post.id }, ...urls['vote_post'] })
}
const votePhoto = async (parish, photo) => {
  return rpc({ params: { parish: parish.id, photo: photo.id }, ...urls['vote_photo'] })
}
const voteVideo = async (parish, video) => {
  return rpc({ params: { parish: parish.id, video: video.id }, ...urls['vote_video'] })
}
const deleteComment = async (parish, comment) => {
  switch (comment.object.type) {
    case 'post':
      return rpc({ params: { parish: parish.id, post: comment.object.id, comment: comment.id }, ...urls['delete_comment_post'] })
    case 'photo':
      return rpc({ params: { parish: parish.id, photo: comment.object.id, comment: comment.id }, ...urls['delete_comment_photo'] })
    case 'video':
      return rpc({ params: { parish: parish.id, video: comment.object.id, comment: comment.id }, ...urls['delete_comment_video'] })
  }

  throw new Error('unknow object type for comment')
}
const deletePhoto = async (parish, photo) => {
  return rpc({ params: { parish: parish.id, photo: photo.id }, ...urls['delete_photo'] })
}
const deleteVideo = async (parish, video) => {
  return rpc({ params: { parish: parish.id, video: video.id }, ...urls['delete_video'] })
}

export default {
  loadPosts,
  loadPhotos,
  loadVideos,
  loadLibrary,
  removeLibraryItem,
  loadPost,
  loadVideo,
  savePost,
  savePhoto,
  saveVideo,
  saveCatalog,
  saveFile,
  loadAboutPriest,
  votePost,
  votePhoto,
  voteVideo,
  sendCommentForPost,
  sendCommentForPhoto,
  sendCommentForVideo,
  deleteComment,
  deletePhoto,
  deleteVideo
}
